module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-at-04fc0408345ee07e66020e73ad3e0018.svg";